/** Register the Compás offline service worker (app shell only). */
export function registerCompasOfflineServiceWorker() {
  if (typeof window === "undefined") return;
  if (!("serviceWorker" in navigator)) return;
  // Avoid SW in CRA/webpack-dev-server — it breaks HMR.
  if (process.env.NODE_ENV !== "production") return;

  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register(`${process.env.PUBLIC_URL || ""}/sw-compas-offline.js`)
      .catch((err) => {
        console.warn("[compas-offline] SW register failed:", err);
      });
  });
}
